(function () {
  function hideBadSellingPlanText() {
    if (!document.body) return;

    var needles = [
      'This item is a deferred, subscription, or recurring purchase',
      "Couldn't load pickup availability"
    ];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue || '';
      if (needles.some(function (needle) { return text.indexOf(needle) !== -1; })) {
        var parent = node.parentElement;
        if (parent) parent.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideBadSellingPlanText();
  });
})();
